import {
  FormType,
  FORM_SECTION_URL_SLUG,
  type FormManagementSection,
} from '../types';

export const getFormManagementUrlWithTab = (
  formType: FormType | FormManagementSection,
): string => {
  if (formType === FormType.CONFLICT_OF_INTEREST || formType === 'COI') {
    return `/form-management/${FORM_SECTION_URL_SLUG.COI}`;
  }
  if (formType === FormType.SPEAK_UP || formType === 'SPEAK_UP') {
    return `/form-management/${FORM_SECTION_URL_SLUG.SPEAK_UP}`;
  }
  return '/form-management';
};

export const getFormManagementTabFromUrl = (
  typeParam: string | undefined,
): FormManagementSection | null => {
  if (typeParam === FORM_SECTION_URL_SLUG.COI) {
    return 'COI';
  }
  if (typeParam === FORM_SECTION_URL_SLUG.SPEAK_UP) {
    return 'SPEAK_UP';
  }
  return null;
};
